<div mat-dialog-title>Licenser</div>
<mat-dialog-content [style.padding-bottom.rem]="0.125">
  <p>Denna mjukvara använder sig av mjukvara från tredje part.</p>

  @if (loadError()) {
    <div>
      <p>Kunde inte ladda licensinformation. Du kan ladda ner filen direkt
        genom länken nedan.</p>
      <a href="/3rdpartylicenses.txt"
         target="_blank"
         aria-label="Ladda ner licenstexter för tredjepartsprogramvara">
        Ladda ner licenstexter
      </a>
    </div>
  } @else {
    <section
      aria-label="Licenstexter för tredjepartsprogramvara">
      <pre>{{ licenseText() }}</pre>
    </section>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button
    mat-dialog-close
    matButton="text">Stäng
  </button>
</mat-dialog-actions>